export default __webpack_public_path__ + "static/media/LENS_CULINARIS_OGRE_complete_6.df8fe725.jpg";